import urlParse from 'url-parse';

export default function hasUserNameByPathParams() {
  // eslint-disable-next-line no-prototype-builtins
  return urlParse(window.location.href, true).query.hasOwnProperty('username');
}
